import api from "./api-service";

export const findAll = () => {
  return api().get("langs");
};

export const save = (lang) => {
  return api().post("langs", lang);
};
